import React from 'react';
import { Tooltip } from 'components/common/modals';
import theme from 'config/theme';
import FAInfoIcon from 'components/common/ui/Vectors/FontAwesome/FAInfoIcon';
import { StageChip } from 'components/common/ui';
import { SUBSCRIPTIONS_TYPES } from '@constants';
import { appendVat, formatCurrencyValue } from '@utils';

export const BOOKINGS_KANBAN_CARD_INFO = [
  {
    key: 'type',
    label: 'Booking Type',
    active: true,
    render: (card) => {
      const isOpen = card.contractType === 'Open';
      const isFixed = card.contractType === 'Fixed';

      const getStyles = () => {
        if (card.subscriptionType != null) {
          if (SUBSCRIPTIONS_TYPES[card.subscriptionType] === 'Temp') {
            return {
              color: theme.palette.oranges.orange700,
              backgroundColor: theme.palette.oranges.orange100,
            };
          }
          if (SUBSCRIPTIONS_TYPES[card.subscriptionType] === 'Predel') {
            return {
              color: theme.palette.violets.violet900,
              backgroundColor: theme.palette.violets.violet200,
            };
          }
        }
        if (isOpen) {
          return {
            color: theme.palette.blues.blue700,
            backgroundColor: theme.palette.blues.blue100,
          };
        }
        if (isFixed) {
          return {
            color: theme.palette.grays.gray700,
            backgroundColor: theme.palette.grays.gray200,
          };
        }
        return {
          color: '#fff',
          backgroundColor: theme.palette.grays.gray500,
        };
      };

      return (
        <StageChip
          styles={{
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: 1,
            padding: '4px',
            height: 'auto',
            ...getStyles(),
          }}
        >
          {SUBSCRIPTIONS_TYPES[card.subscriptionType]
            ? SUBSCRIPTIONS_TYPES[card.subscriptionType]
            : `${card.contract_period}mo`}
        </StageChip>
      );
    },
  },
  { key: 'description', label: 'Brand/Model', active: true },
  {
    key: 'price',
    label: 'Monthly Price',
    active: true,
    group: 'pricing',
    render: (card) => (
      <>
        <span style={{ color: theme.palette.grays.gray700, fontWeight: 600 }}>
          {formatCurrencyValue(card.price, 'en-US')}
        </span>
        <span style={{ color: theme.palette.grays.gray400 }}>/mo</span>
      </>
    ),
  },
  {
    key: 'initialCosts.total',
    label: 'Initial Price',
    active: true,
    group: 'pricing',
    render: (card) => (
      <>
        <span
          style={{
            color: theme.palette.grays.gray400,
          }}
        >
          initial
        </span>{' '}
        <span
          style={{
            color: theme.palette.grays.gray700,
            fontWeight: 600,
          }}
        >
          {formatCurrencyValue(
            {
              number: card.initialCosts?.total,
              currency: card.initialCosts?.currency,
            },
            'en-US'
          )}
        </span>{' '}
        <Tooltip
          title={
            <>
              {(card.initialCosts?.products || []).map((product) => (
                <div key={product.slug}>
                  <span
                    style={{
                      color: '#fff',
                    }}
                  >
                    {product?.category !== product?.name
                      ? `${product?.category} ${product?.name}`
                      : product?.name}
                  </span>{' '}
                  <span
                    style={{
                      color: '#fff',
                    }}
                  >
                    {formatCurrencyValue(
                      {
                        number: appendVat(
                          product?.finalPrice?.number,
                          product?.vat
                        ),
                        currency: product?.finalPrice?.currency,
                      },
                      'en-US'
                    )}
                  </span>
                </div>
              ))}
            </>
          }
          placement="top"
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: theme.palette.blues.blue400,
                padding: '8px',
              },
            },
            arrow: {
              sx: {
                color: theme.palette.blues.blue400,
              },
            },
          }}
        >
          <span>
            <FAInfoIcon />
          </span>
        </Tooltip>
      </>
    ),
  },
  {
    key: 'ticketDetails.labels',
    label: 'Labels',
    active: true,
    render: (card) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          flexWrap: 'wrap',
          marginTop: card?.ticketDetails?.labels?.length > 0 ? '8px' : 0,
        }}
      >
        {card?.ticketDetails?.labels?.map((label) => (
          <StageChip
            key={label}
            styles={{
              fontSize: '0.75rem',
              fontWeight: 400,
              lineHeight: 1,
              color: theme.palette.grays.gray700,
              backgroundColor: theme.palette.grays.gray100,
              padding: '4px',
              height: 'auto',
            }}
          >
            {label}
          </StageChip>
        ))}
      </div>
    ),
  },
  {
    key: 'details',
    label: 'Details (Assignee/Date)',
    active: true,
    group: 'cardFooter',
    render: (card) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '4px',
        }}
      >
        <Tooltip title={card.assignee?.text} placement="top">
          <span
            style={{
              width: '20px',
              minWidth: '20px',
              height: '20px',
              minHeight: '20px',
              borderRadius: '50%',
              backgroundColor: theme.palette.grays.gray500,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: '0.625rem',
              lineHeight: 1,
            }}
          >
            {card.assignee?.shortName}
          </span>
        </Tooltip>
        <span
          style={{
            color: theme.palette.grays.gray400,
            fontSize: '0.75rem',
            lineHeight: 1,
          }}
        >
          {card.updated_at
            ? `Updated at ${card.updated_at}`
            : `Created at ${card.created_at}`}
        </span>
      </div>
    ),
  },
];
